import React, { Fragment, ReactNode, useEffect } from "react";
import { useHistory } from "react-router";
import { useResolveNotification } from "src/store/notifications/useActions";
import {
  PUSH_WEB_VIEW_URL,
  RESOLVE_NOTIFICATION,
  WebViewDispatchTypes,
} from "../../utils/nativeUtils";

export type EventDataType = {
  type: WebViewDispatchTypes;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
};

type Props = {
  children: ReactNode;
};

const WebViewEventListenerAssigner = ({ children }: Props) => {
  const { push } = useHistory();
  const resolveNotification = useResolveNotification();

  const callbackAction = ({ detail }: CustomEvent<EventDataType>) => {
    switch (detail.type) {
      case PUSH_WEB_VIEW_URL: {
        push(detail.data);
        break;
      }
      case RESOLVE_NOTIFICATION: {
        if (detail.data) {
          resolveNotification(Number(detail.data));
        }
        break;
      }
      default:
    }
  };

  useEffect(() => {
    window.addEventListener("webViewDispatch", callbackAction as EventListener);
    return () => {
      window.removeEventListener(
        "webViewDispatch",
        callbackAction as EventListener
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Fragment>{children}</Fragment>;
};

export default WebViewEventListenerAssigner;
